<template>
  <section id="company_container" class="custom-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <div class="columns v-align-center">
      <div class="column">
        <b-field label="Empresa*">
          <treeselect :options="companiesList"
                      :show-count="true"
                      :flat="true"
                      v-model="companiesIds"
                      :limit="4"
                      placeholder="Seleccione empresa y/o parqueadero"/>
        </b-field>
      </div>


      <div class="column input-search-content">
        <b-field class="input-search" label="Buscar">
          <b-input
              placeholder="Buscar"
              type="text"
              name="search"
              v-model="search"
              icon-right="magnify"
              icon-right-clickable
              @icon-right-click="editModal = true"
          >
          </b-input>
        </b-field>
        <b-field class="pagination-select mt-button">
          <b-select
              placeholder="Páginas"
              expanded
              v-model="pagination"
              name="pagination"
          >
            <option
                v-for="option in paginationList"
                :value="option.id"
                :key="option.id"
                :id="option.id"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column text-right">
        <vs-button
            color="primary"
            icon="add"
            class="btn-add-device"
            @click="addEntity"
        >Crear acceso nuevo
        </vs-button
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData"
                 :loading="loading"
                 paginated
                 backend-pagination
                 :total="totalPages"
                 :per-page="perPage"
                 @page-change="onPageChange"
                 aria-next-label="Siguiente"
                 aria-previous-label="Anterior"
                 aria-page-label="Página"
                 aria-current-label="Página actual"
                 backend-sorting
                 :default-sort-direction="defaultSortOrder"
                 :default-sort="[sortField, sortOrder]"
                 @sort="onSort">
          <b-table-column
              field="company.code"
              label="Identificación"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ props.row.identification }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="company.code" label="Nombre" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.name }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="company.name" label="Email" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.email }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="company.name" label="Estado" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.status }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="title" label="Código Usuario" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                <text-highlight :queries="search">
                  {{ props.row.usuCodigo }}
                </text-highlight>
              </span>
            </div>
          </b-table-column>
          <b-table-column
              field="acciones"
              label="acciones"
              sortable
              centered
              v-slot="props">
            <button
                class="btn primary edit"
                v-on:click="editRow(props.row.codeAccess)"
                title="Editar">
              <span class="material-icons"> edit </span>
            </button>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="checkPages()">
        <vs-pagination
            :max="5"
            :total="totalPages"
            v-model="page"
            prev-icon="arrow_back"
            next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import accessEndpoint from "@/endpoints/core/AccessEndpoint";
import companyEndpoint from "@/endpoints/core/CompanyEndpoint";

export default {
  data: () => ({
    isLoading: false,
    company: null,
    companies: [],
    selected: null,
    tableData: [],
    perPage: 50,
    totalNumData: 0,
    originalData: [],
    search: "",
    page: 1,
    defaultSortOrder: "asc",
    sortOrder: "asc",
    sortField: "name",
    forRemove: null,
    pagination: 10,
    totalPages: 0,
    paginationList: [
      {id: 10, label: "10"},
      {id: 30, label: "30"},
      {id: 60, label: "60"},
      {id: 100, label: "100"},
      {id: 1000, label: "1000"},
    ],
    loading: false,
    companiesList: [],
    companiesIds: null,
  }),
  async mounted() {
    this.companiesList = await companyEndpoint.listCompanies();
    this.listCompanyCode(this.companiesList);
    this.getAccessList();

  },
  watch: {
    search: function (value) {
      this.tableData = this.originalData.filter((item) => {
        const string = JSON.stringify(item);
        return new RegExp(`${value}`, "igm").test(string);
      });
    },
    page: function () {
      this.splitData();
    },
    companiesIds: function () {
      this.getAccessList();
    },
  },
  methods: {
    listCompanyCode(companiesList) {
      let list = [];
      companiesList.forEach(item => {
        list.push(item.code);
        if (item.children) {
          list = [...list, ...this.listCompanyCode(item.children)];
        }
      });
      return list;
    },
    processSelection() {
      let list = [];
      this.companiesIds.forEach(companyId => {
        const company = this.findCompany(this.companiesList, companyId);
        if (company) {
          const access = {company, appList: structuredClone(this.menu)};
          list.push(access);
        }
      });
      this.selectedAccess = list;
      this.forceRender++;
    },
    getAccessList() {
      this.isLoading = true;
      const objAccess = {
        companyId: this.companiesIds,
        page: this.page - 1,
      };
      accessEndpoint.listByCompany(objAccess)
          .then(data => {
            if (data.info === null) {
              this.tableData = [];
              this.isLoading = false;
              return;
            }
            this.isLoading = false;
            this.originalData = data.info;
            this.totalPages = data.info[0]['totalRecords'];
            this.splitData();
          });
    },
    onPageChange(page) {
      this.page = page;
      this.getAccessList();
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.find();
    },
    splitData() {
      this.originalData.forEach(value => {
        const userCodeList = JSON.parse(value.usuCodigo)
            .filter(value => value !== null);
        if (!userCodeList || userCodeList.length <= 0) {
          value.usuCodigo = null;
        }
      });
      if (!this.checkPages()) {
        this.tableData = this.originalData;
        return;
      }
      this.totalPages = Math.ceil(this.totalNumData / this.pagination);
      const offset = Math.round((this.page - 1) * this.pagination);
      const limit = Math.round(this.pagination * this.page);
      this.tableData = this.originalData.slice(offset, limit);
    },
    checkPages() {
      return this.totalNumData > this.pagination;
    },


    addEntity() {
      this.$router.push("/view/users/management");
    },


    editRow(accessCode) {
      this.$router.push({name: "Administrar accesos", params: {accessCode: accessCode}});
    },
  },
};
</script>

<style>
.sub-title {
  font-size: 1.6em;
  margin: 0;
  padding: 0;
}

.custom-container {
  margin-top: 20px;
}

.input-search {
  max-width: 300px;
}

.btn-add-device {
  margin-left: auto;
}

.text-right {
  display: flex;
  justify-content: flex-end;
}

.name-options-table {
  display: flex;
  width: 100%;
}

.name-options-table .options {
  margin-left: auto;
}

.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}

.name-options-table .options .btn span {
  font-size: 1.5em;
}

.name-options-table .options .btn:last-child {
  margin-right: 0;
}

.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}

.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}

.pagination-select {
  max-width: 120px;
}

.input-search-content {
  display: flex;
}

.label-badge {
  display: block;
  width: 100%;
  padding: 0 5px;
  text-align: center;
  border-radius: 5px;
}

.label-badge.badge-secondary {
  background-color: #b4c4d3 !important;
}
</style>
